import Profile from 'components/global/Profile';

const LenderProfile = () => <Profile />;

export default LenderProfile;
